import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './CartTableModifiersList.css'
import { joinFieldByCommas } from '../../../../utils/reducer-utils'

export const CartTableModifiersListComponent = ({ modifiers, editable }) => {
  return (
    <ul data-testid='cart-item-modifiers' styleName={cx('modifiers', { readonly: !editable })}>
      {modifiers.map(({ name, modifiers: nestedModifiers = [] }, index) => {
        const isLast = index === modifiers.length - 1
        // must use index here because GUID will be null for special instructions modifier
        return (
          <li data-testid='cart-item-modifier' key={index} styleName='modifier'>
            {name}{nestedModifiers.length > 0 && <span styleName='nestedModifier'> ({joinFieldByCommas('name')(nestedModifiers)})</span>}{(!editable && !isLast) && ', '}
          </li>
        )
      })}
    </ul>
  )
}

CartTableModifiersListComponent.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    modifiers: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  })),
  editable: PropTypes.bool
}

export const CartTableModifiersListTestComponent = CartTableModifiersListComponent

export const CartTableModifiersList = React.memo(CartTableModifiersListComponent)
CartTableModifiersList.displayName = 'CartTableModifiersList'
